import {
  Box,
  Heading,
  Text,
  VStack,
  Card,
  CardHeader,
  CardBody,
  SimpleGrid,
  Button,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { PageMeta } from '../components/PageMeta'

const CFOPMethod = () => {
  return (
    <Box py={8}>
      <PageMeta title="cfop.pageTitle" description="cfop.pageDescription" />
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="xl" mb={4}>CFOP Method</Heading>
          <Text fontSize="lg" mb={8}>
            The CFOP method (also known as the Fridrich method) is one of the most popular speedcubing methods.
            It consists of four steps: Cross, F2L (First Two Layers), OLL (Orientation of Last Layer), and PLL (Permutation of Last Layer).
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <Card>
            <CardHeader>
              <Heading size="md">Cross</Heading>
            </CardHeader>
            <CardBody>
              <Text mb={4}>
                The first step is to solve the cross on one face (traditionally the white face).
                This creates a foundation for solving the first two layers.
              </Text>
            </CardBody>
          </Card>

          <Card>
            <CardHeader>
              <Heading size="md">F2L (First Two Layers)</Heading>
            </CardHeader>
            <CardBody>
              <Text mb={4}>
                The second step involves simultaneously solving the first two layers by pairing up corner-edge pairs
                and inserting them into their correct positions.
              </Text>
            </CardBody>
          </Card>

          <Card>
            <CardHeader>
              <Heading size="md">OLL (Orientation of Last Layer)</Heading>
            </CardHeader>
            <CardBody>
              <Text mb={4}>
                The third step orients all pieces in the last layer so that the top face shows all yellow
                (if you started with white on bottom).
              </Text>
              <Button as={Link} to="/oll" colorScheme="blue">
                Learn OLL Algorithms
              </Button>
            </CardBody>
          </Card>

          <Card>
            <CardHeader>
              <Heading size="md">PLL (Permutation of Last Layer)</Heading>
            </CardHeader>
            <CardBody>
              <Text mb={4}>
                The final step permutes the pieces of the last layer while keeping their orientation,
                completing the cube.
              </Text>
              <Button as={Link} to="/pll" colorScheme="blue">
                Learn PLL Algorithms
              </Button>
            </CardBody>
          </Card>
        </SimpleGrid>
      </VStack>
    </Box>
  )
}

export default CFOPMethod 